import React, { useState, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { isLoggedInUser, isOneTouchUser } from '../../../utility/authUtils';
import { OrganizerUpdatePreview } from '@paypalcorp/donate-react';
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react';
import {
  handleLikeUpdate,
  addUpdateIdParameter,
} from '../organizerUpdatesUtils';
import { useHistory } from 'react-router';
import templateData from '../../../utility/getTemplateData';
import LoginPopupSheet from '../../loginPopup/loginPopupSheet';
import { trackUpdatesListLikePressed } from '../../../fpti/fpti';
import { MessageFormat, RelativeTimeFormat } from '@paypalcorp/worldready';

const UpdatePreview = ({
  update,
  handleUpdatePreviewCardClick,
  setCurrentUpdate,
  setShowLikeError,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoginSheetOpen, setLoginSheetOpen] = useState(false);
  const orgName = templateData.donationName ?? '';
  const campaignId = templateData.productId;
  const history = useHistory();
  const worldReady = useContext(WorldReadyContext);

  const getLikeButtonContent = (liked) => {
    return new MessageFormat(worldReady, {
      id: `common.organizerUpdates.updated.a11y.${
        liked ? '' : 'un'
      }selectedLike`,
    }).format({
      number: update?.reactions?.[0]?.count ?? 0,
    });
  };

  const handleButtonClick = useCallback(async (updateId, isLiked) => {
    trackUpdatesListLikePressed(updateId, !isLiked);
    setShowLikeError(false);
    if (!isLoggedInUser() && !isOneTouchUser()) {
      addUpdateIdParameter(updateId, history.push);
      setLoginSheetOpen(true);
      return;
    }

    setIsLoading(true);
    try {
      const result = await handleLikeUpdate(isLiked, campaignId, updateId);
      if (result.ok) {
        setCurrentUpdate({ id: updateId, isLiked: !isLiked });
      } else {
        setShowLikeError(true);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      setShowLikeError(true);
    }
  });

  const relativeTimeFormatter = new RelativeTimeFormat(worldReady, {
    timeZone: templateData.timezone,
    unit: 'day',
  });

  return (
    <>
      <OrganizerUpdatePreview
        organizerUpdateTitle={update.subject}
        organizerUpdateContent={JSON.parse(update.text)}
        date={new Date(update.time_updated)}
        relativeTimeFormatter={relativeTimeFormatter}
        clickHandler={() => handleUpdatePreviewCardClick(update.fou_id)}
        likeButtonProps={{
          onClick: (event) => {
            handleButtonClick(
              update?.fou_id,
              update?.reactions?.[0]?.currentUserReacted ?? false
            );
            event.stopPropagation();
          },
          amount: update?.reactions?.[0]?.count ?? 0,
          isLiked: update?.reactions?.[0]?.currentUserReacted ?? false,
          btnState: isLoading ? 'processing' : 'initial',
          isReadOnly: false,
          content: getLikeButtonContent(
            update?.reactions?.[0]?.currentUserReacted ?? false
          ),
        }}
      />
      <LoginPopupSheet
        isSheetOpen={isLoginSheetOpen}
        closeSheet={() => setLoginSheetOpen(false)}
        orgName={orgName}
      />
    </>
  );
};

UpdatePreview.propTypes = {
  update: PropTypes.object,
  handleUpdatePreviewCardClick: PropTypes.func,
  setCurrentUpdate: PropTypes.func,
  setShowLikeError: PropTypes.func,
};

export default UpdatePreview;
